export default "__VITE_ASSET__D7aZtaX7__"